<template>
  <div class="clients">
    <div class="main-actions">
      <button class="floater" @click="addClient()"><i class="far fa-plus"></i></button>
    </div>
    <div class="content">
      <client-list :clients="clients" v-model="client" class="client-list"></client-list>
      <client-form :invoices="invoices" v-model="client" class="client-form"></client-form>
      <client-invoices :clients="clients" :client="client" :invoices="invoices" class="client-invoices"></client-invoices>
      <invoice-template v-if="selectedInvoice" :invoice="selectedInvoice" class="invoice-selected  a4"></invoice-template>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import ClientList from "@/components/client/ClientList"
import ClientForm from "@/components/client/ClientForm"
import ClientInvoices from "@/components/client/ClientInvoices"
import InvoiceTemplate from "@/components/invoice/InvoiceTemplate"
export default {
  name: "clients",
  components: {
    ClientList,
    ClientForm,
    ClientInvoices,
    InvoiceTemplate
  },
  data() {
    return {
      client: null
    };
  },
  computed: {
    clients() {
      return this.$store.getters.clients;
    },
    invoices() {
      if(this.client){
        return this.$store.getters.invoicesByClient(this.client.id);
      }
      return []
    },
    selectedInvoice() {
      return this.$store.getters.selectedInvoice;
    },
  },
  methods: {
    addClient() {
      this.$store.dispatch('addClient', {
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        company: 'A new client',
        }).then(client => {
          this.client = client
        })
    }
  }
};
</script>

<style lang="scss" scoped>
.clients {
  .content {
    margin-top: 30px;
    display: flex;
    .client-list {
      margin: 0 10px;
    }
  }
}
</style>
